import { Component, OnInit } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { RegistrationFormService } from '../../services/data/registration-form.service';
import { Logger } from '../../services/logger.service';
import { Router } from '@angular/router';
import { VisitorRegistrationFormHeader } from '../../models/visitor-registration-form-header';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { renderDate, renderEnumTranslated, renderFromId } from '../../utils/data-tables-utils';
import { Site } from '../../models/site';
import { SiteService } from '../../services/data/site.service';
import { VisitorRegistrationFormType } from '../../models/visitor-registration-form-type';
import { Api } from 'datatables.net';
import { ToastService } from '../../services/toast.service';

const log = new Logger('forms-for-review');

@Component({
  selector: 'app-approved-forms-list',
  standalone: true,
  imports: [
    TranslateModule,
    DataTablesModule,
  ],
  templateUrl: './approved-forms-list.component.html',
  styleUrl: './approved-forms-list.component.scss'
})
export class ApprovedFormsListComponent implements OnInit {
  sites: Site[] = [];
  dataTableOptions: any = {};

  constructor(
    private router: Router,
    private siteService: SiteService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private registrationFormService: RegistrationFormService) {
  }

  navigateToForm(form: VisitorRegistrationFormHeader) {
    this.navigateTo(form.id, form.formType);
  }

  navigateTo(formId: string, formType: VisitorRegistrationFormType) {
    if (formType === VisitorRegistrationFormType.BusinessTrip) {
      this.router.navigate(['/view/stv/', formId]);
    } else if (formType === VisitorRegistrationFormType.WorkOnSite) {
      this.router.navigate(['/view/sta/', formId]);
    }
  }

  refresh(dtInstance: Api) {
    dtInstance.ajax.reload();
    this.showToaster('', 'Refreshed');
}

showToaster(title: string, message: string) {
  this.toastService.show(title, message, {
    classname: 'bg-success text-light',
    delay: 2000,
    autohide: true,
  });
}
  ngOnInit(): void {
    this.siteService.sites$.subscribe(
      (sites) => this.sites = sites
    )

    this.dataTableOptions = {
      info: false,
      stateSave:true,
      ajax: (dataTableParameters: any, callback: any) => {
        this.registrationFormService.getApprovedForms().subscribe(
          (data) => {
            callback({
              recordsTotal: data.length,
              recordsFiltered: data.length,
              data: data
            });
          }
        )
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        $(row).off('click');
        $(row).on('click', () => { this.navigateToForm(data as VisitorRegistrationFormHeader); });
        return row;
      },
      columns: [
        {
          title: "Visitor",
          data: "visitor",
          className: "dt-right",
          defaultContent: ''
        },
        {
          title: "Work Function",
          data: "workFunction",
          className: "dt-right",
          defaultContent: '',
          visible: false,
        },
        {
          title: "Company Name",
          data: "companyName",
          className: "dt-right",
          defaultContent: '',
          visible: false
        },
        {
          title: "Group Responsible",
          data: "visitingGroupResponsible.name",
          className: "dt-right",
          defaultContent: '',
          visible: false
        },
        {
          title: "Group Responsible (email)",
          data: "visitingGroupResponsible.emailAddress",
          className: "dt-right",
          defaultContent: '',
          visible: false
        },
        {
          title: "AESC Responsible",
          data: "hostCountryResponsible.name",
          className: "dt-right",
          defaultContent: '',
          visible: false
        },
        {
          title: "AESC Responsible (email)",
          data: "hostCountryResponsible.emailAddress",
          className: "dt-right",
          defaultContent: '',
          visible: false
        },
        {
          title: "Site",
          data: "siteId",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderFromId(this.sites, data, type)
        },
        {
          title: "Type",
          data: "formType",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderEnumTranslated(this.translateService, data, type)
        },
        {
          title: "Status",
          data: "formStatus",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderEnumTranslated(this.translateService, data, type),
          visible: false
        },
        {
          title: "Review Reason",
          data: "reviewReason",
          className: "dt-right",
          defaultContent: '',
          visible: false
        },
        {
          title: "Review Before",
          data: "reviewOn",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderDate(data, type),
          visible: false
        },
        {
          title: "Exp. Arrival",
          data: "expectedArrival",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderDate(data, type)
        },
        {
          title: "Exp. Departure",
          data: "expectedDeparture",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderDate(data, type)
        },
        {
          title: "Approved On",
          data: "approvedOn",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderDate(data, type)
        }
      ],
      layout: {
        topStart: {
          buttons: [
            {
              text: '<i class="bi bi-arrow-clockwise"></i> Refresh',
              key: '1',
              action: (e: any, dt: any, node: any, config: any) => this.refresh(dt)
            },
            'spacer',
            {
              extend: 'colvis',
              text: '<i class="bi bi-layout-three-columns"></i> Columns',
            },
            'spacer',
            {
              extend: 'excel',
              text: '<i class="bi bi-file-earmark-excel"></i> Export to Excel',
            }
          ],
        }
      }
    };
  }
}
